export default __webpack_public_path__ + "static/media/card-responsive.357e7754.png";